module.exports = __webpack_public_path__ + "img/Rescue-kit.54fbe4e5.jpg";